import styled from 'styled-components';
import { motion } from 'framer-motion';

import { fontStyles, palette } from 'theme';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  column-gap: 15px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

export const Head = styled(motion.button).attrs(({ $isOpen, $lastItem }) => ({
  animate: {
    borderBottomColor: ($lastItem && palette.black) || $isOpen ? palette.black : palette.white,
  },
  transition: {
    borderBottomColor: { duration: 0, delay: $isOpen ? 0 : 0.25 },
  },
  initial: { borderBottomColor: palette.white },
}))`
  display: grid;
  grid-template-columns: auto 1fr 28px;
  align-items: center;
  column-gap: 10px;
  min-height: 48px;
  width: 100%;
  ${fontStyles.textUpper}
  line-height: 1.1;
  text-align: left;
  width: 100%;
  border: solid ${palette.black};
  color: ${palette.black};
  border-width: 2px 0;
  &:before {
    content: '${({ $id }) => $id}';
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  @media (max-width: 400px) {
    hyphens: auto;
  }
`;

const getAnimation = ({ $isOpen }) => ({
  animate: {
    height: $isOpen ? 'auto' : 0,
    display: $isOpen ? 'block' : 'none',
  },
  transition: {
    height: { duration: 0.3 },
    display: { delay: $isOpen ? 0 : 0.3 },
  },
  initial: {
    height: 0,
    display: 'none',
  },
});

export const ExtraContent = styled(motion.div).attrs(getAnimation)`
  grid-column: 1/2;
  grid-row: 2/3;
  overflow: hidden;
`;

export const Content = styled(motion.div).attrs(getAnimation)`
  grid-column: 2/3;
  grid-row: 1/3;
  overflow: hidden;
  @media (max-width: 991px) {
    grid-column: 1/2;
    grid-row: 4/5;
  }
`;

export const Text = styled.p`
  ${fontStyles.text}
  margin: 15px 0;
`;
